import React, { useState, useEffect, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { vehiclesLisitingRequest, deleteVehicles, addBulkVehicleRequest } from '../vehicles/redux/vehiclesDispatcher';
import { getMakeListing } from '../make/redux/makeDispatcher';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import AddVehicle from '../vehicles/components/AddVehicles';

function VehiclesListingTable() {
  const dispatch = useDispatch();
  const location = useLocation();
  const vehiclesListing = useSelector(state => state.vehiclesReducer);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [makes, setMakes] = useState([]);
  const [all, setAll] = useState([]);

  const debounceRef = useRef(null);

  const columns = [
    {
      field: "id",
      headerName: "NO",
      width: 60,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
    },
    { field: "registration_number", headerName: "VRM", width: 100 },
    { field: "vrc", headerName: "VRC", width: 100 },
    { field: "make", headerName: "Make", width: 100 },
    { field: "model", headerName: "Model", width: 100 },
    { field: "title", headerName: "Variant", width: 100 },
    { field: "body_type", headerName: "Body Type", width: 100 },
    { field: "engine_size", headerName: "Engine Size", width: 100 },
    { field: "fuel_type", headerName: "Fuel", width: 100 },
    { field: "colour", headerName: "Color", width: 100 },
    { field: "year", headerName: "Year", width: 100 },
    { field: "transmission", headerName: "Transmission", width: 100 },
    { field: "number_of_seats", headerName: "Seats", width: 100 },
    { field: "tax_status", headerName: "Tax Status", width: 120 },
    { field: "tax_fee", headerName: "Tax Fee", width: 120 },
    { field: "nct_expiry", headerName: "Tax Expiry", width: 120 },
    { field: "tax_duration", headerName: "Tax Duration", width: 120 },
    { field: "co2", headerName: "CO2 Emission", width: 120 },
    { field: "co", headerName: "CO", width: 120 },
    { field: "hc", headerName: "HC", width: 120 },
    { field: "nox", headerName: "NOX", width: 120 },
    { field: "hcnox", headerName: "HCNOX", width: 120 },
    { field: "particulates", headerName: "Particulates", width: 120 },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "6px", height:"100%", alignItems:"center" }}> 
          <AddVehicle
            buttonLabel="Edit"
            editMode={true}
            vehicleData={params.row}
            makeList={makes}
            allList={all}
          />
          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "40px",
              height:"24px",  // Increased height
              display: "flex",
              alignItems: "center",
              // alignSelf:"end",
              justifyContent: "center",
            }}
          >
            Delete
          </button>
        </div>
      )
    }
  ];

  const handleDelete = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to delete vehicle "${row.registration_number}"`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(deleteVehicles(row.id));
      }
    });
  };

// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  dispatch(getMakeListing())
    .then(result => {
      setAll(result);
      setMakes(result.filter(make => make.parent_name === "__ROOT__"));
    })
    .catch(err => console.error("Error fetching makes", err));
}, []); // eslint-disable-line react-hooks/exhaustive-deps

// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  if (debounceRef.current) clearTimeout(debounceRef.current);
  debounceRef.current = setTimeout(() => {
    dispatch(vehiclesLisitingRequest(page + 1, pageSize, searchTerm));
  }, 400);
  return () => clearTimeout(debounceRef.current);
}, [page, pageSize, searchTerm, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "text/csv") {
      dispatch(addBulkVehicleRequest({ file }))
        .then(() => window.location.reload())
        .catch((err) => {
          console.error(err);
          alert("Failed to upload CSV");
        });
    } else {
      alert("Please select a valid CSV file.");
    }
  };

  return (
    <Paper sx={{ height: "95%", width: '100%' }}>
      <div style={{
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <input
          type="text"
          placeholder="Search by VRM, Make, Model, etc..."
          value={searchTerm}
          onChange={(e) => {
            setPage(0);
            setSearchTerm(e.target.value);
          }}
          style={{
            padding: "6px 10px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "50%"
          }}
        />
        <div style={{ display: "flex", gap: "10px" }}>
          <input
            type="file"
            accept=".csv"
            id="csvUpload"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <button
            onClick={() => document.getElementById("csvUpload").click()}
            style={{
              backgroundColor: "black",
              color: "white",
              height:"30px",
              padding: "4px 10px",
              fontSize:"14px",
              border: "none",
              borderRadius: "4px"
            }}
          >
            Import CSV
          </button>
          <AddVehicle buttonLabel="Add Vehicle" makeList={makes} allList={all} />
        </div>
      </div>

      <DataGrid
        rows={vehiclesListing.vehiclesListing || []}
        columns={columns}
        rowCount={vehiclesListing.totalVehicles || 0}
        // pageSize={pageSize}
        // page={page}
         paginationModel={{ page, pageSize }}
        paginationMode="server"
        onPaginationModelChange={({ page, pageSize }) => {
          console.log("pagination----",page,pageSize);
          setPage(page);
          setPageSize(pageSize);
        }}
        pageSizeOptions={[10, 25, 50]}
        loading={vehiclesListing.loading}
        rowHeight={36}
        disableRowSelectionOnClick
      />
    </Paper>
  );
}

export default VehiclesListingTable;
